import env from '@polleverywhere/core/lib/env'
import Survey from '@polleverywhere/core/lib/models/survey'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'

export default async function feedback (state, appOptions, lastPage) {
  const Feedback = (await import(/* webpackChunkName: 'component-feedback' */ '../../components/feedback')).default

  const view = new Feedback({
    user: state.get('user'),
    model: new Survey({ participant_key: env.get('feedback_participant_key') })
  })

  view.on('complete', () => store.dispatch(appSlice.pageUpdated(lastPage)))
  view.on('done', () => store.dispatch(appSlice.pageUpdated(lastPage)))
  view.on('submit', submission => this.trigger('feedback:submit', submission))

  return view
}
